<soft-ds-empty-state
  icon="fa-regular fa-user-magnifying-glass"
  size="lg"
  [title]="'#CUSTOMER.EMPTY.TITLE' | translate"
  [description]="'#CUSTOMER.EMPTY.DESCRIPTION' | translate"
  data-testid="kundenabfrage-empty-state"
/>
